import request from '#api/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type CreateAwardArgs = {
  gotAt: Date;
  name: string;
  institution: string;
};

export default function useEditAwardMutation() {
  let awardId = '';
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, args }: { id: string; args: CreateAwardArgs }) => {
      awardId = id;
      // API 호출
      const res = await request<string>({
        method: 'patch',
        url: `/awards/${id}/update`,
        data: args
      });

      return res.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['awards']
      });
      await queryClient.invalidateQueries({
        queryKey: ['AWARDS', `${awardId}`]
      });
    }
  });
}
